import mapFunction from './mapResources';

export default mapFunction('material_categories', {
    isFetching: false,
    items: []
});
